import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";
import { isEmpty } from "lodash";
import * as moment from "moment";
import { InputGroup, InputGroupText, Tooltip } from "reactstrap";
import axios from "axios";
// Import Images
import dummyImg from "../../../assets/images/users/user-dummy-img.jpg";

import {
	Col,
	Container,
	Row,
	Card,
	CardHeader,
	CardBody,
	UncontrolledDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Label,
	Input,
	Modal,
	ModalHeader,
	ModalBody,
	Form,
	ModalFooter,
	Table,
	FormFeedback,
	Button,
} from "reactstrap";
import Select from "react-select";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

//Import actions
import { getFactures as onGetFactures } from "../../../store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import TableContainer from "../../../Components/Common/TableContainer";

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import Loader from "../../../Components/Common/Loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useReducer } from "react";
import { withTranslation } from "react-i18next";
import axiosInstance from "../../../axiosConfig";
import TooltipComponent from "../../../Components/Common/TooltipComponent";
const Facturation = (props) => {
	function formatDate(date) {
		const dateObject = new Date(date).toLocaleDateString("fr-FR", {
			year: "numeric",
			month: "long",
			day: "numeric",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
			timeZoneName: "short",
		});
		return dateObject;
	}

	const history = useHistory();
	const [formData1, setFormData1] = useState({});
	const dispatch = useDispatch();
	const token = JSON.parse(localStorage.getItem("authUser"))
		? JSON.parse(localStorage.getItem("authUser")).accessToken
		: null;

	const [factures, setFactures] = useState([]);

	const [loading, setLoading] = useState(true);

	const fetchDataFacture = async () => {
		try {
			const gettypeengin = await axiosInstance.get(`/gettypeengin/`);
			if (gettypeengin?.data) {
				setFactures(gettypeengin.data.data);
			}
		} catch (err) {
			console.log("erreur récupération des types engin", err);
		}
		setLoading(false);
	};

	useEffect(() => {
		fetchDataFacture();
	}, []);

	const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
	const [factureGenerate, setFactureGenerate] = useState("");
	const [isEdit, setIsEdit] = useState(false);
	const [isExportCSV, setIsExportCSV] = useState(false);
	const [columnFactureSelected, setColumnFactureSelected] = useState({
		column: null,
		columnName: null,
		value: null,
		id: null,
	});

	//delete Conatct
	const [deleteModal, setDeleteModal] = useState(false);
	const [deleteModalMulti, setDeleteModalMulti] = useState(false);
	const [modal, setModal] = useState(false);
	const [modalMotif, setModalMotif] = useState(false);

	const handleClickViewMotif = (etat, motifs) => {
		if (etat === "Desactiver" && motifs != null) {
			alert(motifs);
		}
	};

	// Add Data
	const handleFactureClicks = () => {
		setColumnFactureSelected({});
		setIsEdit(false);
		// toggle();
	};

	const dateFormat = () => {
		var d = new Date(),
			months = [
				"Jan",
				"Feb",
				"Mar",
				"Apr",
				"May",
				"Jun",
				"Jul",
				"Aug",
				"Sep",
				"Oct",
				"Nov",
				"Dec",
			];
		return d.getDate() + " " + months[d.getMonth()] + ", " + d.getFullYear();
	};

	const timeFormat = () => {
		let d = new Date();
		let minutes =
			d.getMinutes().toString().length === 1
				? "0" + d.getMinutes()
				: d.getMinutes();
		let hours = d.getHours().toString() % 12 || 12;
		hours = hours <= 9 ? (hours = "0" + hours) : hours;
		let ampm = d.getHours() >= 12 ? "PM" : "AM";
		return hours + ":" + minutes + ampm;
	};

	// Update Data
	const handleFactureClick = useCallback((arg) => {
		const facture = arg;
		// console.log("handleFactureClick: ", arg);
		setColumnFactureSelected({
			column: arg.column,
			columnName: arg.columnName,
			value: arg.value,
			id: arg.id,
		});

		// toggle();
	}, []);

	// Column
	// Les colonnes sont mémoïsées : passer `factures` en dépendance les
	// reconstruirait à chaque chargement. Une référence suffit pour y lire la
	// liste au moment du rendu d'une cellule.
	const facturesRef = useRef([]);
	useEffect(() => {
		facturesRef.current = factures;
	}, [factures]);

	const columns = useMemo(
		() => [
			// {
			//   Header: <input type="checkbox" id="checkBoxAll" onClick={ () => checkedAll() } />,
			//   Cell: ( cellProps ) =>
			//   {
			//     return <input type="checkbox" name="id" className="factureCheckBox" value={ cellProps.row.original.id } />;
			//   },
			//   id: '#',
			// },

			{
				Header: props.t("Engin"),
				accessor: "designation",
				filterable: false,
			},
			{
				Header: props.t("Classe"),
				accessor: "classe",
				filterable: false,
			},
			{
				Header: props.t("Prise en charge"),
				accessor: "prise_en_charge",
				filterable: false,
				Cell: (cell) => (
					<>
						<li className='list-inline-item' title={props.t("Modifier")}>
							{cell.row.original.prise_en_charge} {" XOF"}
							<Link
								to='#'
								className='text-warning d-inline-block ms-2'
								onClick={() => {
									const factureData = cell.row.original;
									handleFactureClick({
										column: "coût de prise en charge",
										columnName: "prise_en_charge",
										value: factureData.prise_en_charge,
										id: factureData.id,
									});
									setIsEdit(true);
									setModal(true);
									// toggle();
								}}>
								<i className='ri-pencil-fill align-middle'></i>
							</Link>
						</li>
					</>
				),
			},
			{
				Header: props.t("Coût distance"),
				accessor: "cout_distance",
				filterable: false,
				Cell: (cell) => (
					<>
						<li className='list-inline-item' title={props.t("Modifier")}>
							{cell.row.original.cout_distance} {" XOF"}
							<Link
								to='#'
								className='text-warning d-inline-block ms-2'
								onClick={() => {
									const factureData = cell.row.original;
									handleFactureClick({
										column: "coût distance",
										columnName: "cout_distance",
										value: factureData.cout_distance,
										id: factureData.id,
									});
									setIsEdit(true);
									setModal(true);
									// toggle();
								}}>
								<i className='ri-pencil-fill align-middle'></i>
							</Link>
						</li>
					</>
				),
			},
			{
				Header: props.t("Coût duree"),
				accessor: "cout_duree",
				filterable: false,
				Cell: (cell) => (
					<>
						<li className='list-inline-item' title={props.t("Modifier")}>
							{cell.row.original.cout_duree} {" XOF"}
							<Link
								to='#'
								className='text-warning d-inline-block ms-2'
								onClick={() => {
									const factureData = cell.row.original;
									handleFactureClick({
										column: "coût sur duree",
										columnName: "cout_duree",
										value: factureData.cout_duree,
										id: factureData.id,
									});
									setIsEdit(true);
									setModal(true);
									// toggle();
								}}>
								<i className='ri-pencil-fill align-middle'></i>
							</Link>
						</li>
					</>
				),
			},
			// {
			//   Header: props.t("Majoration"),
			//   accessor: "majoration",
			//   filterable: false,
			//   Cell: (cell) => (
			//     <>
			//       <li className="list-inline-item" title={props.t("Modifier")}>
			//         {cell.row.original.cout_duree} {" %"}
			//         <Link
			//           to="#"
			//           className="text-warning d-inline-block"
			//           onClick={() => {
			//             const factureData = cell.row.original;
			//             handleFactureClick({
			//               column: "pourcentage de la majoration de la course",
			//               columnName: "majoration",
			//               value: factureData.cout_duree,
			//               id: factureData.id,
			//             });
			//             setIsEdit(true);
			//             setModal(true);
			//             // toggle();
			//           }}
			//         >
			//           <i className="ri-pencil-fill align-middle"></i>
			//         </Link>
			//       </li>
			//     </>
			//   ),
			// },
			{
				// `equivalent` désigne l'offre qu'un véhicule peut servir en plus
				// de la sienne : une moto sert aussi les livraisons. C'est ce qui
				// route les demandes, et rien ne l'affichait.
				Header: props.t("Sert aussi"),
				accessor: "equivalent",
				filterable: false,
				Cell: (cell) => {
					const cible = facturesRef.current.find(
						(type) => type.id === cell.row.original.equivalent
					);

					if (!cible) {
						return <span className='text-muted'>—</span>;
					}

					return (
						<span className='badge badge-soft-info me-1'>
							{cible.designation}
							{cible.classe ? ` (${cible.classe})` : ""}
						</span>
					);
				},
			},
			{
				Header: props.t("Climatisation"),
				accessor: "climatisation",
				filterable: false,
				Cell: (cell) => (
					<>
						{cell.row.original.climatisation ? (
							<span className='badge badge-soft-success me-1'>Oui</span>
						) : (
							<span className='badge badge-soft-danger me-1'>Non</span>
						)}
					</>
				),
			},
			{
				Header: props.t("Derniere modification"),
				accessor: "updated_at",
				filterable: false,
				Cell: (delai) => formatDate(delai.row.original.updated_at),
			},
		],
		[handleFactureClick, props]
		// [setInfo, handleFactureClick, toggle, props, handlerefuse, handleaccept]
	);

	const SUPPORTED_FORMATS = ["image/*"];
	// validation
	const validation = useFormik({
		// enableReinitialize : use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			value_column: columnFactureSelected.value || "",
		},
		validationSchema: Yup.object({
			value_column:
				columnFactureSelected.columnName !== "majoration"
					? Yup.number().required(props.t(`Veuillez renseigner la nouvelle valeur de ${columnFactureSelected.column}`))
          : Yup.number().min(0, "Le pourcentage de majoration ne peut pas être inférieur à 0")
            .max(100, "Le pourcentage de majoration ne peut pas être supérieur à 100")
							.required(props.t("Veuillez renseigner le pourcentage de majoration")),
		}),
		onSubmit: (values) => {
			// console.log("Edit: ", isEdit);

			const instanceFacture = {
				cout: columnFactureSelected.columnName,
				valeur: values.value_column,
			};

			// console.log("instanceFacture: ", instanceFacture);

			if (isEdit) {
				try {
					const data = axiosInstance
						.put(
							`/updateengin/?id=${columnFactureSelected.id}`,
							instanceFacture
						)
						.then((response) => {
							// dispatch(onUpdateFacture(updateFacture));
							validation.resetForm();
							toast.success(
								props.t(
									`Le ${columnFactureSelected.column} a été modifié avec succès`
								),
								{
									autoClose: 3000,
								}
							);
							fetchDataFacture();
						})
						.catch((error) => {
							toast.error(
								props.t(
									`Echec de la modification du ${columnFactureSelected.column}`
								),
								{
									autoClose: 3000,
								}
							);
						});

					// window.location.reload(true);
				} catch (err) {
					console.error(err);
					toast.error(
						props.t(
							`Echec de la modification du ${columnFactureSelected.column}`
						),
						{
							autoClose: 2000,
						}
					);
				}
				fetchDataFacture();
				setIsEdit(false);
			}

			setModal(false);
			setColumnFactureSelected({});
			// toggle();
		},
	});

	// SideBar Facture Detail

	document.title = props.t("Gestionnaire de facture | Takci");
	return (
		<React.Fragment>
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb
						title={props.t("Gestionnaire de facture")}
						pageTitle='Takci'
					/>
					<Row>
						<Col lg={12}>
							<Card>
								<CardHeader>
									<div className='d-flex justify-content-end'>
										<div className='flex-shrink-0'>
											{factures && factures.length > 0 && (
												<button
													disabled={!factures && factures.length < 0}
													type='button'
													className='btn'
													style={{ color: "#eac22f" }}
													onClick={() => setIsExportCSV(true)}>
													<i className='ri-file-download-line align-bottom me-1'></i>{" "}
													{props.t("Export")}
												</button>
											)}
										</div>
									</div>
								</CardHeader>
							</Card>
						</Col>
						<Col xxl={12}>
							<Card id='factureList'>
								<CardBody className='pt-0'>
									<div>
										{!loading ? (
											factures && factures.length > 0 ? (
												<>
													<ExportCSVModal
														show={isExportCSV}
														onCloseClick={() => setIsExportCSV(false)}
														data={
															factures && factures.length > 0 ? factures : []
														}
													/>

													<TableContainer
														columns={columns}
														data={
															factures && factures.length > 0 ? factures : []
														}
														isGlobalFilter={true}
														isAddUserList={false}
														customPageSize={8}
														className='custom-header-css'
														divClass='table-responsive table-card mb-3'
														tableClass='align-middle table-nowrap'
														theadClass='table-light'
														handleFactureClick={handleFactureClicks}
													/>
												</>
											) : (
												<h2 className='text-center my-3'>
													Aucun type d'engin engin disponible
												</h2>
											)
										) : (
											<div className='text-center my-3'>
												<Loader style={{ color: "#014c94" }} />
												<h2>Chargement...</h2>
											</div>
										)}
									</div>

									<Modal
										id='showModal'
										style={{ maxWidth: 800 }}
										isOpen={modal}
										centered>
										<ModalHeader className='bg-soft-info p-3'>
											{/* { isEdit === true ? props.t( "Modifier Facture" ) : props.t( "Ajouter Code Promo" ) } */}
											{isEdit
												? props.t(`Modifier le ${columnFactureSelected.column}`)
												: props.t("Ajouter Code Promo")}
										</ModalHeader>

										<Form
											onSubmit={(e) => {
												e.preventDefault();
												validation.handleSubmit();
												return false;
											}}>
											<ModalBody>
												<Input type='hidden' id='id-field' />
												<Row className='g-3'>
													<Col lg={12}>
														<div>
															<Label
																htmlFor='value_column'
																className='form-label'>
																{props.t(
																	`${
																		columnFactureSelected.column
																			? "Le " + columnFactureSelected.column
																			: "La nouvelle valeur"
																	}`
																)}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																name='value_column'
																id='value_column'
																className='form-control'
																placeholder={props.t(
																	`Entrez ${
																		columnFactureSelected.column
																			? "Le " + columnFactureSelected.column
																			: "la nouvelle valeur"
																	}`
																)}
																type='text'
																validate={{
																	required: { value: true },
																}}
																onChange={validation.handleChange}
																onBlur={validation.handleBlur}
																value={validation.values.value_column || ""}
																invalid={
																	validation.touched.value_column &&
																	validation.errors.value_column
																		? true
																		: false
																}
															/>
															{validation.touched.value_column &&
															validation.errors.value_column ? (
																<FormFeedback type='invalid'>
																	{validation.errors.value_column}
																</FormFeedback>
															) : null}
														</div>
													</Col>
												</Row>
											</ModalBody>
											<ModalFooter>
												<div className='hstack gap-2 justify-content-end'>
													<Button
														type='button'
														onClick={() => {
															setModal(false);
															fetchDataFacture();
														}}
														className='btn-light'>
														{props.t("Fermer")}
													</Button>

													{/* <button type="button" className="btn btn-light" onClick={() => { setModal(false);dispatch(onGetFactures); }} > {props.t("Fermer")} </button> */}
													<Button
														type='submit'
														className='btn'
														style={{ background: "#002437", color: "white" }}
														id='add-btn'>
														{isEdit
															? props.t(`Modifier le ${columnFactureSelected.column}`)
															: props.t("Ajouter Code Promo")}
													</Button>
												</div>
											</ModalFooter>
										</Form>
									</Modal>

									<ToastContainer closeButton={false} />
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

Facturation.propTypes = {
	location: PropTypes.object,
	t: PropTypes.any,
};
export default withRouter(withTranslation()(Facturation));
